var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "style=stroke"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9604 13.9604C14.2045 13.7163 14.6002 13.7163 14.8443 13.9604L18.1448 17.2609C18.3889 17.505 18.3889 17.9007 18.1448 18.1448C17.9007 18.3889 17.505 18.3889 17.2609 18.1448L13.9604 14.8443C13.7163 14.6002 13.7163 14.2045 13.9604 13.9604Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.21596 15.51C12.6921 15.51 15.51 12.6921 15.51 9.21596C15.51 5.73983 12.6921 2.92188 9.21596 2.92188C5.73983 2.92188 2.92188 5.73983 2.92188 9.21596C2.92188 12.6921 5.73983 15.51 9.21596 15.51ZM9.21596 16.76C13.3825 16.76 16.76 13.3825 16.76 9.21596C16.76 5.04948 13.3825 1.67188 9.21596 1.67188C5.04948 1.67188 1.67188 5.04948 1.67188 9.21596C1.67188 13.3825 5.04948 16.76 9.21596 16.76Z",
    fill: "#414042"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.9a130bada608cfc2eb3ef4266f896119.svg";
export { ForwardRef as ReactComponent };